import * as React from "react";
import C from "classnames";
import { Link } from "react-router-dom";
const sizeMapper = {
    lg: "btn-lg",
    sm: "btn-sm",
};
const variantMapper = (outline) => {
    if (outline) {
        return {
            primary: "btn-outline-primary",
            secondary: "btn-outline-secondary",
            success: "btn-outline-success",
            info: "btn-outline-info",
            warning: "btn-outline-warning",
            danger: "btn-outline-danger",
            light: "btn-outline-light",
            dark: "btn-outline-dark",
            white: "btn-outline-white",
        };
    }
    else {
        return {
            primary: "btn-primary",
            secondary: "btn-secondary",
            success: "btn-success",
            info: "btn-info",
            warning: "btn-warning",
            danger: "btn-danger",
            light: "btn-light",
            dark: "btn-dark",
            white: "btn-white",
        };
    }
};
/**
 * Button Something Something Something
 */
export const Button = React.forwardRef(({ variant = "primary", id, size, children, rounded, outline, block, active, title, disabled, onClick, className, close, submit, to, href, download, testId, style, }, ref) => {
    return href ? (React.createElement("a", { href: href, download: download, className: C("btn", className && className, variant && variantMapper(outline)[variant], size && sizeMapper[size], rounded && "btn-rounded-circle", active && "active", disabled && "disabled", block && "btn-block"), id: id, title: title, "data-testid": testId, style: style }, children)) : to ? (React.createElement(Link, { to: to, id: id, className: C("btn", className && className, variant && variantMapper(outline)[variant], size && sizeMapper[size], rounded && "btn-rounded-circle", active && "active", disabled && "disabled", block && "btn-block"), "data-testid": testId, style: style }, children)) : !close ? (React.createElement("button", { type: submit ? "submit" : "button", id: id, className: C("btn", className && className, variant && variantMapper(outline)[variant], size && sizeMapper[size], rounded && "btn-rounded-circle", active && "active", disabled && "disabled", block && "btn-block"), disabled: disabled, onClick: onClick, "data-testid": testId, style: style, ref: ref }, children)) : (React.createElement("button", { id: id, style: Object.assign(Object.assign({}, style), { fontSize: size === "sm" && "inherit", marginLeft: size === "sm" && "2px" }), type: submit ? "submit" : "button", className: C("close", className && className, size && sizeMapper[size]), "aria-label": "Close", onClick: onClick, ref: ref },
        React.createElement("span", { "aria-hidden": "true" }, "\u00D7")));
});
//# sourceMappingURL=Button.js.map